export default __webpack_public_path__ + "static/media/icon_photo-outline-2.52d21a72.svg";